
// UPDATED IMPORT PATH to match your specified file structure
import { chatscopeApi,  RowChatState, } from './useChatSlice';
import { RawMessage, CreateConversationFromRaw, RawConversation, RawConversationOptionalId } from "./chatSelectors";
import { isFetchBaseQueryError } from "./profilesSlice";
import { chatApi } from "./ChatSlice";
import { printError } from "../app/utils";
import { ChatState } from '@chatscope/use-chat';
import { GetPopulateStateMethod } from './chatService';
import { setLastRefreshUnreadMessageCount } from './dialogSlice';
import {  store } from '../app/store'
import { selectSessionRTK, selectIsAuthenticated } from './userTokenManagementSlice'
import { getUnreadMessagesAllConverstations } from '../components/messaging/ChatScopeUseChat';


// --- Define the types expected by the service from the RTK Query slice ---
// NOTE: These are placeholders. You should replace them with your actual Redux types.
type RootState = any;
type AppDispatch = any;

/**
 * Selects the initial timestamp from the RTK Query cache for the specific userId.
 * This looks up the result of the 'getChatState' query in the Redux store.
 */
const selectInitialTimestampFromCache = (getState: () => RootState, /*conversationId: number,*/): any => {
    const state = getState();
    // The cache key includes the stringified argument (the userId)
    //const parmString = JSON.stringify(parmObject)
    //const cacheKey = `getChatState(${parmString})`;// `getChatState({"userId":${userId}})`;
    const cacheKey = Object.keys(state.chatscopeApi?.queries).filter((key) => key.startsWith('getChatState')).pop();
    const cacheEntry = cacheKey ? state.chatscopeApi.queries[cacheKey] : undefined;

    if (cacheEntry && cacheEntry.status === 'fulfilled' && cacheEntry.data) {
        // We use the renamed property: lastMessageTimestamp
        return { ts: cacheEntry?.data?.length ? (cacheEntry.data[0].retrieved_at_ts || null) : null, status: cacheEntry?.status, data: cacheEntry.data };
    }
    return { ts: null, status: cacheEntry?.status }
};
const environmentREACT_APP_ENV: string = process.env.REACT_APP_ENV || 'development'
// --- HELPER TYPES & CONSTANTS ---
export const POLLING_INTERVAL_MS = (environmentREACT_APP_ENV === 'development') ? 10000 : environmentREACT_APP_ENV === 'test' ? 10000 : environmentREACT_APP_ENV === 'prod' ? 5000 : 5000; // 30 seconds


export type ServiceState = {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    isInitialized: boolean
    error?: Error;
    data?: any,
};
// --- CORE SERVICE IMPLEMENTATION ---
export type ChatStateUpdate = {
    rawChatStateData: RowChatState;
    newMessagesOnly: boolean;
    latestHandledTimestamp: string | null;
    userId: number,
    serviceState: ServiceState
};

const INITIAL_TIMESTAMP = '1970-01-01T00:00:00.000Z';

export class PollingChatDataService {

    private dispatch: AppDispatch;
    private getState: () => RootState;
    private userId: number | undefined; // Stored user ID


    //private conversationId: number = 0;
    private serviceStateListeners: Set<(s: ServiceState) => void> = new Set();
    private setServiceState = (serviceState: ServiceState) => {
        this.serviceState = serviceState;
        this.serviceStateListeners.forEach(cb => {
            try { cb(serviceState) } catch (e) { console.error('serviceStateListener error:', e) }
        });
    }
    private serviceState: ServiceState = { isInitialized: false, isLoading: false, isError: false, isSuccess: false }
    // Handle to the in-flight RTK Query fetch (if any). Used to abort when
    // resetForUser is called mid-fetch so the wrong user's data never
    // populates chatscope storage.
    private currentFetch: { abort: () => void } | undefined = undefined;
    // Internal state to track the latest timestamp of the message successfully processed by the client.

    private latestHandledTimestamp: string | null = INITIAL_TIMESTAMP;
    private latestHandledTS: number = 0;
    private lastRetrievedConversationIds: number[] = []

    private resetLatestHandledTimestamp = () => this.latestHandledTimestamp = INITIAL_TIMESTAMP

    private pollingIntervalId: number | null = null;


    // CONSTRUCTOR: Now requires the userId
    constructor(
        //chatStorage: IStorage,
        //update: UpdateState,
        dispatch: AppDispatch,
        getState: () => RootState,
        // REQUIRED: ID of the currently authenticated user
        userId?: number,
        //conversationId: number
        //setServiceState: (serviceState: ServiceState) => void
        //onSend: (message: RawMessage, convo: Conversation) => void

    ) {
        //this._chatStorage = chatStorage;
        //this.updateState = update;
        this.dispatch = dispatch;
        this.getState = getState;
        this.userId = userId; // Store userId
        //this.onSend = onSend
        // 1. Initiate the RTK Query to fetch the initial state using the userId
        if (this.userId) {
            const gloabalState = getState()
            //const convoId = this._chatStorage.getState().activeConversation            
            //queueMicrotask(() => this.getConvoAnMessageState({ userId: this.userId, }));
        }
    }
    //private subscribers = new Map<object, { chatStateUpdateFunc: (update: ChatStateUpdate) => void,  conversations: number[] | undefined}>();
    private subscribers = new Map<object, (update: ChatStateUpdate) => void>();
    //const populateStateMethod = GetPopulateStateMethod(chatStorageConversations)
    subscribe(storageObject: any, cb?: (update: ChatStateUpdate) => void, userId?: number | undefined) {
        if (!cb) {
            cb = GetPopulateStateMethod(storageObject)
        }
        this.subscribers.set(storageObject, cb);
        //this.userId = userId
        if ((this.userId != userId || this.latestHandledTimestamp === INITIAL_TIMESTAMP) && userId && this.subscribers.size === 2) {
            //queueMicrotask(() => this.getConvoAnMessageState({ userId: this.userId }));
            this.resetForUser(userId);
        }
        return {
            deleteSubscription: () => {
                this.subscribers.delete(cb)
            }, resetForUser: this.resetForUser,
        };
    }

    // async updateMessageRead(messageId: number) {
    //     try {
    //       //const result =  await this.dispatch(markMessageReadThunk(messageId, this.userId!));
    //       //  return result;
    //         store.dispatch(markMessageRead({ messageId, userId: this.userId! }));
    //     } catch (err) {
    //         if (typeof err === 'object' && err !== null) {
    //             console.error('Mutation failed:', JSON.stringify(err));
    //         } else {
    //             console.error('Mutation failed:', err);
    //         }
    //     }
    // }


async  markMessageRead(messageId: number) {
  try {
    // Kept as a lightweight fire-and-forget POST (called per incoming message — chatService onMessage; RTK
    // would add mutation-state churn/unwrap per message). Backend derives the user from the verified token —
    // the userId in the body is ignored server-side now.
    const state = store.getState();
    // Skip for GUESTS — mark-read is guarded server-side (requireAuth), so a guest request just 403s + adds
    // warn noise, and guest read-state (shared profile 361) isn't meaningful anyway.
    if (!selectIsAuthenticated(state)) return;
    const session = selectSessionRTK(state);
    // Federated sends the Bearer; custom/phone rides its httpOnly cookie (auto-sent same-origin).
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (session?.access_token) {
      headers['Authorization'] = `Bearer ${session.access_token}`;
    }
    await fetch('/api/chat/setReadMessage', {
      method: 'POST',
      headers,
      body: JSON.stringify({ messageId, userId: this.userId! }),
    });
    // backend called, no need to await result
  } catch (err) {
    console.error('Failed to mark message read:', err);
  }
}


    private publish(update: ChatStateUpdate) {
        //const totalUnreadMessageCount = update.rawChatStateData.reduce((prev, curr) => prev + (curr.unread_message_count ?? 0), 0)
        //store.dispatch(setLastRefreshUnreadMessageCount(totalUnreadMessageCount))
        this.subscribers.forEach(cb => {
            try {
                cb(update)
            } catch (error) {
                console.error("Publish Error:", error)
            }
        });
          store.dispatch(setLastRefreshUnreadMessageCount(getUnreadMessagesAllConverstations()??0))
    }
    public getUserId() {
        return this.userId
    }
    public resetForUser(userId: number) {
        this.dispose()
        this.userId = userId
        if (this.userId) {
            // If a fetch is in-flight (for the previous user), abort it so its
            // response never populates chatscope storage and never overwrites
            // latestHandledTimestamp / restarts polling. Clear isLoading so the
            // queued cold fetch below isn't dropped by the isLoading guard.
            this.currentFetch?.abort();
            this.currentFetch = undefined;
            this.setServiceState({ ...this.serviceState, isLoading: false });
            //const convoId = this._chatStorage.getState().activeConversation
            //this.getConvoAnMessageState({ userId: this.userId, })
            queueMicrotask(() => this.getConvoAnMessageState({ userId: this.userId, }));//timestamp default doesnt even matter, since not passing the first time around
        }

    }

    public getServiceState: () => ServiceState = () => { return { ...this.serviceState } }
    // Additive: each call registers a listener; returns an unsubscribe.
    // No filter at this layer — listeners see every state transition and
    // apply their own policy (e.g. ignore refresh polls).
    public attachSetServiceStateFunc(cb: (s: ServiceState) => void): () => void {
        this.serviceStateListeners.add(cb);
        return () => { this.serviceStateListeners.delete(cb); };
    }

    private waitForCacheThenInit() {
        const intervalId = setInterval(() => {
            const { ts, status } = selectInitialTimestampFromCache(this.getState);
            if (status === 'fulfilled' && ts !== undefined) {
                clearInterval(intervalId);
                this.latestHandledTimestamp = ts;
                this.startPolling(); // now safe to start polling
            }
        }, 50); // check every 50ms or whatever makes sense
    }


    // --- State Access ---
    public getLatestMessageTimestamp(): string | null {
        return this.latestHandledTimestamp;
    }

    // --- Polling Logic ---
    private startPolling() {
        this.stopPolling();
        this.pollingIntervalId = window.setInterval(this.pollForMessages, POLLING_INTERVAL_MS) as unknown as number;
    }

    private stopPolling() {
        if (this.pollingIntervalId !== null) {
            clearInterval(this.pollingIntervalId);
            this.pollingIntervalId = null;
        }
    }

    public dispose() {
        this.stopPolling();
        this.resetLatestHandledTimestamp()
        //this._chatStorage.clearState()
    }




    private pollForMessages = async () => {
        const lastCheckedTime = this.getLatestMessageTimestamp();//????????????????????
        if (!lastCheckedTime) {
            return
        }
        //const lastRetrievedConversationIds: number[] = this._chatStorage.getState().conversations.map(c => c.data?.savedId ?? Number(c.id))
        //conversation_list
        await this.getConvoAnMessageState({ userId: this.userId, lastRetrievedTS: lastCheckedTime, lastRetrievedConversationIds: this.lastRetrievedConversationIds })
    }

    private async getConvoAnMessageState(parmObj: any) {
        // Mark loading
        //this serviceState
        if (this.serviceState.isLoading) {
            return
        }
        const newMessagesOnly = !!parmObj.lastRetrievedTS
        this.setServiceState({ ...this.serviceState, isLoading: true, isError: false, isSuccess: false, data: { newMessagesOnly } });
        // TEMP TEST (disabled): simulate slow cold-start fetch (2s) for iPhone diagnosis.
        // if (!newMessagesOnly) {
        //     await new Promise(r => setTimeout(r, 2000));
        // }
        //console.info(parmObj)
        const stateQueryThunk = chatscopeApi.endpoints.getChatState.initiate(parmObj);

        //const result = await this.dispatch(pollThunk).unwrap();
        const fetchHandle = this.dispatch(stateQueryThunk);
        this.currentFetch = fetchHandle;
        try {
            //this.dispatch(chatscopeApi.util.resetApiState());
            var rawChatStateDataUntyped = await fetchHandle.unwrap()// Unwrap the promise to get the final payload
            var rawChatStateData = rawChatStateDataUntyped as RowChatState
            for (var delayCount = 0; !rawChatStateData && delayCount < 1000; delayCount++) {
                const { ts, status, data } = selectInitialTimestampFromCache(this.getState);
                if (status === 'fulfilled' && ts !== undefined) {
                    rawChatStateData = data
                    break; // cache ready
                }
                await new Promise(resolve => setTimeout(resolve, 50)); // wait 50ms before next check
            }
            if (!rawChatStateData) {
                console.error('cant be rawChatStateData:', rawChatStateData)
                throw new Error(`Max delay count of 1000 for valid rawChatStateData exceeded`)
            }

            const dateString = rawChatStateData?.length ? (rawChatStateData[0].retrieved_at_ts || null) : null
            //4. Initialize the timestamp
            if (dateString === this.latestHandledTimestamp) {
                console.error('cant be', dateString, this.latestHandledTimestamp)
            }
            this.latestHandledTimestamp = dateString
            this.lastRetrievedConversationIds = rawChatStateData?.map(c => c.id ?? 0)

            //const { conversationAddedCount, messagesAddedCount } = this.processStateResult(rawChatStateData, newMessagesOnly)
            // Update internal state silently first (no listener notification yet)
            // so publish() carries the post-fetch serviceState into subscribers.
            const newServiceState: ServiceState = { ...this.serviceState, ...!newMessagesOnly ? { isInitialized: true, } : {}, isLoading: false, isError: false, isSuccess: true, data: { newMessagesOnly, conversationCount: rawChatStateData.length, latestHandledTimestamp: this.latestHandledTimestamp } };
            this.serviceState = newServiceState;
            if (this.userId) {
                this.publish({ rawChatStateData: rawChatStateData, newMessagesOnly, latestHandledTimestamp: this.latestHandledTimestamp, userId: this.userId, serviceState: newServiceState }) //must be sync
            }
            // NOW notify lifecycle-state listeners — storage is populated, so
            // when UI re-renders due to isLoading:false, conversations/messages
            // are already available via useChat().
            this.setServiceState(newServiceState);

            //this.dispatch(chatscopeApi.util.resetApiState());
            if (!newMessagesOnly) {
                this.startPolling();
            }
        } catch (error: unknown) { // ⬅️ Satisfies TS error 7006
            // If the fetch was aborted by resetForUser, skip all side effects —
            // a new cold fetch was already queued for the new user.
            const errName = (error as any)?.name;
            if (errName === 'AbortError' || errName === 'ConditionError') {
                return;
            }
            var errorString = `Initial chat state fetch failed: ${printError(error)}`
            // Use the type guard to safely narrow the type
            // if (isFetchBaseQueryError(error)) {
            //     // Here, error is typed as FetchBaseQueryError
            //     errorString += `Server Error (${error.status}): ${ printError(error) }`//(error.data as any)?.error} `
            // } else if (error instanceof Error) {
            //     // Here, error is typed as Error (which covers SerializedError's base)
            //     errorString += `JS Runtime Error: ${error.message}`;
            //     //this.setServiceState({ ...this.serviceState, isLoading: false, isError: true, isSuccess: fase, error })
            //     //console.error(errorString);
            //     //return
            // } else {
            //     // Fallback for truly unknown errors
            //     errorString += `Unknown Error Object: ${error}`;
            // }
            console.error(errorString);
            this.setServiceState({ ...this.serviceState, isLoading: false, isError: true, isSuccess: false, error: error instanceof Error ? error : new Error(errorString) })
            if (this.userId) {
                this.publish({ rawChatStateData: [], newMessagesOnly, latestHandledTimestamp: this.latestHandledTimestamp, userId: this.userId, serviceState: this.serviceState }) //must be sync
            }
        } finally {
            if (this.currentFetch === fetchHandle) {
                this.currentFetch = undefined;
            }
            this.dispatch(chatscopeApi.util.resetApiState());
        }
    }


    disconnect() {
        this.stopPolling();
    }


}
